import React, { useState } from 'react';

import { CloseOutlined } from '@ant-design/icons';
import { Modal } from 'antd';

import isBefore from 'date-fns/isBefore';

import {
  idsModalInadimplencia,
  idsModalOrderBump,
  idsModaLowTicket,
  idsModalRvp,
  idsModalSubscription,
  idsModalUpsell
} from './IdsShowModal';

const arrayModais: {
  users: number[];
  image: string;
  link: string;
  closeIconColor: string;
}[] = [
  {
    users: idsModalInadimplencia,
    image: '/img/activation-campaign/recuperacao-inadimplencia.svg',
    link: 'https://my2.eduzz.com/subscriptions/mass-charge',
    closeIconColor: '#fff'
  },
  {
    users: idsModalSubscription,
    image: '/img/activation-campaign/subscriptions.svg',
    link: 'https://orbita.eduzz.com/producer/product/newproduct',
    closeIconColor: '#fff'
  },
  {
    users: idsModalOrderBump,
    image: '/img/activation-campaign/orderbump.svg',
    link: 'https://sun-admin.eduzz.com/orderbump',
    closeIconColor: '#000'
  },
  {
    users: idsModaLowTicket,
    image: '/img/activation-campaign/low-ticket.svg',
    link: 'https://orbita.eduzz.com/producer/product/newproduct',
    closeIconColor: '#000'
  },
  {
    users: idsModalRvp,
    image: '/img/activation-campaign/rvp-internal.svg',
    link: 'https://ajuda.eduzz.com/hc/pt-br/articles/1260807625289-como-funciona-o-recuperador-de-vendas-eduzz',
    closeIconColor: '#000'
  },
  {
    users: idsModalUpsell,
    image: '/img/activation-campaign/upsell.svg',
    link: 'https://ajuda.eduzz.com/hc/pt-br/articles/1260807654450-o-que-%C3%A9-um-upsell-one-click-buy-e-como-configur%C3%A1-lo-no-checkout-sun',
    closeIconColor: '#000'
  }
];

export default function ActivationCampaign({ userId }: { userId: number }) {
  const campaignStorageName = 'activation-campaign-seen-04-2026';
  const alreadySeen = JSON.parse(localStorage.getItem(campaignStorageName));
  const [open, setOpen] = useState(!alreadySeen);
  const isCampaignAtive = isBefore(new Date(), new Date('2026-05-13'));
  const modalSelected = arrayModais.find(item => item.users.includes(userId));

  const handleClose = () => {
    setOpen(false);
    localStorage.setItem(campaignStorageName, 'true');
  };

  if (!modalSelected || !isCampaignAtive) {
    return null;
  }

  return (
    <Modal
      open={open}
      onCancel={handleClose}
      centered
      footer={null}
      closable={false}
      width='min(98vw, 700px)'
      styles={{
        content: {
          padding: 0,
          backgroundColor: 'transparent',
          boxShadow: 'none',
          borderRadius: 0,
          overflow: 'visible'
        },
        body: { padding: 0, overflow: 'visible' }
      }}
    >
      <div
        className='relative w-full bg-cover bg-center'
        style={{ paddingBottom: '100%', backgroundImage: `url(${modalSelected.image})` }}
      >
        <CloseOutlined
          className='absolute top-[26px] right-[32px] z-10 cursor-pointer text-lg'
          style={{ color: modalSelected.closeIconColor }}
          onClick={handleClose}
        />
        <a href={modalSelected.link} target='_blank' rel='noreferrer' className='absolute inset-0 block' />
      </div>
    </Modal>
  );
}
